<template>
	<div v-if="loginMember !== null">
		<div class="tab-title-box" v-if="viewType !== 'receive' && viewType !== 'send'">
			<h1 v-text="viewType === 'consult' ? '1:1온라인상담' : '자주하는질문'">1:1온라인상담</h1>
			<nav-link :url="'/qna/consult/new'" v-if="viewType === 'consult' && seqNo == null">
				<button class="greenlineBtn">등록</button>
			</nav-link>
			<div class="display-inline float-right" v-if="modifyYn === 'true'">
				<button class="lineBtn back mr-1 md" @click="deleteConsultDetail">삭제</button>
				<button class="greenBtn md modify-btn" @click="modifyDetail">수정</button>
			</div>
		</div>
		<div class="tab-title-box" v-else>
			<nav-link class="title" :class="viewType === 'receive' ? 'select' : ''" :url="'/qna/receive'">수신함</nav-link>
			<nav-link class="title" :class="viewType === 'send' ? 'select' : ''" :url="'/qna/send'">발송함</nav-link>
			<nav-link v-if="seqNo == null" :url="'/qna/send/new'">
				<button class="greenlineBtn">쪽지쓰기</button>
			</nav-link>
			<button v-if="viewType === 'receive' && seqNo != null" class="greenlineBtn" @click="modifyDetail">답장</button>
		</div>
		<div class="search-bar web-hide">
			<input placeholder="검색" v-model="keywords" v-on:keyup.enter="searchKeyword" />
		</div>
		<Detail v-if="seqNo" :viewType="viewType" :seqNo="seqNo" />
		<List v-else :viewType="viewType" />
	</div>
</template>

<script>
import CONST from '@/constants';
import imgPin from '../../assets/images/icon/icon-pin@2x.png';
import List from '@/components/qna/List';
import Detail from '@/components/qna/Detail';
import eventBus from '@/plugins/event-bus';

export default {
	title: 'Q&A 메인',
	name: 'QnAMain',
	components: { List: List, Detail: Detail },
	props: ['seqNo', 'viewType', 'modifyYn'],
	data: function() {
		return {
			loginMember: null,
			imgPin: imgPin,
			select: 1,
			boardType: '',
			keywords: '',
		};
	},
	watch: {
		viewType: function(v) {
			this.listPage = 1;
			if (v === 'consult') {
				// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA_CONSULT');
				this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
			} else if (v === 'qna') {
				this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA');
			} else {
				// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA_RECEIVE');
				this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
			}
		},
	},
	created() {},
	mounted() {
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
		if (this.viewType === 'consult') {
			// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA_CONSULT');
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		} else if (this.viewType === 'qna') {
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA');
		} else {
			// this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'QNA_RECEIVE');
			this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'COMMUNITY');
		}
	},
	computed: {},
	methods: {
		searchKeyword: function() {
			// if (this.keyword === '') {
			// 	alert('검색어를 입력해 주세요.');
			// 	return false;
			// }
			eventBus.$emit('LOAD_QNA_DATA', this.keywords);
		},
		modifyDetail: function() {
			if (this.viewType === 'consult') {
				this.$device.pushView('/qna/consult/new/modify/' + this.seqNo);
			} else {
				this.$device.pushView('/qna/send/new/reply/' + this.seqNo);
			}
		},
		deleteConsultDetail: function() {
			if (confirm('삭제하시겠습니까?')) {
				let formData = new FormData();
				formData.append('qnaSeqNo', this.seqNo);
				this.$apiClient
					.getInstance()
					.post(this.$apiClient.getApiServer() + '/api/board/onlineConsultDelete.do', formData)
					.then(res => {
						if (res.data.resultCode !== 0) {
							window.alert(res.data.resultMsg);
							this.$device.pushView('/qna/' + this.viewType);
						} else {
							alert('삭제되었습니다.');
							this.$device.pushView('/qna/' + this.viewType);
						}
					})
					.catch(e => {
						console.error(e);
						window.alert(e.message);
					});
			}
		},
	},
};
</script>

<style scoped></style>
